import * as Effects from '@redux-saga/core/effects'

export const call: any = Effects.call
export const put: any = Effects.put
export const takeLatest: any = Effects.takeLatest
export const takeEvery: any = Effects.takeEvery
export const fork: any = Effects.fork
export const select: any = Effects.select
export const delay: any = Effects.delay
